import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { Link, withRouter, RouteComponentProps } from 'react-router-dom'
import { injectIntl, FormattedMessage, WrappedComponentProps } from 'react-intl'
import { BusinessStatus, hasSimpleModeFlag, simpleModeSearchPair } from 'utils'
import { BreadcrumbGroup } from 'shared-global-ec-uikit/components/dist/react/esm/components/breadcrumb-group'
import { Breadcrumb } from 'shared-global-ec-uikit/components/dist/react/esm/components/breadcrumb'
import Meta, { createPageTitle } from 'components/Meta'
import getConstants from '../../constants'
import StoreDetails from 'containers/StoreDetails'
import TemporaryUnavailable from 'containers/TemporaryUnavailable'
import { selector as mapStateToProps } from './selectors'
import * as requestActions from 'services/Request/actions'
import NotFound from '../NotFound'
import { getURLWithoutQuery } from '../../helpers/url'
import { LoadingIndicator } from 'shared-global-ec-uikit/components/dist/react/esm'
import { isNativeAppByUserAgent } from 'helpers/nativeApp'

const mapDispatchToProps = (dispatch: Dispatch<ActionType>) => ({
  clearError: () => dispatch(requestActions.clearError()),
})

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouteComponentProps<{ storeId: string }> &
  WrappedComponentProps

const CONSTANTS = getConstants()
class DetailsPage extends Component<Props> {
  render() {
    const {
      storeEntities,
      match: {
        params: { storeId },
      },
      location: { search },
      intl,
      hasUnavailableError,
      clearError,
      isRequestingStoreDetail,
    } = this.props
    const homeUrl = hasSimpleModeFlag(search)
      ? `/?${simpleModeSearchPair}`
      : '/'

    const storeDetails =
      storeEntities[storeId] ||
      Object.values(storeEntities).find(store => store.locationId === storeId)
    if (hasUnavailableError) {
      return <TemporaryUnavailable componentWillUnmountCallback={clearError} />
    }

    if (typeof storeDetails === 'undefined') {
      if (isRequestingStoreDetail) {
        return <LoadingIndicator variant="full-screen" />
      }
      return <NotFound />
    }

    const { name, businessStatus } = storeDetails

    return (
      <>
        <Meta
          title={createPageTitle(name, intl)}
          description={`${name} ${intl.formatMessage({
            id: 'text_store_locator_details_meta_description',
          })}`}
          canonicalUrl={getURLWithoutQuery()}
          shouldAddNoIndexMeta={businessStatus === BusinessStatus.DISCONTINUED}
        />
        {!isNativeAppByUserAgent() && (
          <BreadcrumbGroup>
            <Breadcrumb element="a" href={CONSTANTS.HOME_PAGE_URL}>
              <FormattedMessage id="text_breadcrumbs_top" />
            </Breadcrumb>
            <Breadcrumb element={Link} to={homeUrl}>
              <FormattedMessage id="text_storesearch" />
            </Breadcrumb>
            <Breadcrumb element="a" href={undefined}>
              {name}
            </Breadcrumb>
          </BreadcrumbGroup>
        )}
        <StoreDetails storeDetails={storeDetails} />
      </>
    )
  }
}

const DetailsPageWithIntl = injectIntl(DetailsPage)
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DetailsPageWithIntl),
)
